<template>
  <!-- COPIED FROM THE ORIGINAL WEBSITE -->
  <div class="header-wrapper">
    <div class="home__header">
      <header>
        

      </header>

      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  components: {},
  computed: {
    ...mapGetters(['currentUser']),
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/mixins.scss';
@import '@/scss/transitions.scss';

@font-face {
  font-family: 'Open Sans';
  src: url('../../assets/fonts/OpenSans-Bold.woff2') format('woff2'),
    url('../../assets/fonts/OpenSans-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  src: url('../../assets/fonts/OpenSans-SemiBold.woff2') format('woff2'),
    url('../../assets/fonts/OpenSans-SemiBold.woff') format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  src: url('../../assets/fonts/OpenSans-Light.woff2') format('woff2'),
    url('../../assets/fonts/OpenSans-Light.woff') format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  src: url('../../assets/fonts/OpenSans-Regular.woff2') format('woff2'),
    url('../../assets/fonts/OpenSans-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.clear {
  display: block;
  clear: both;
}

.header-wrapper {
  color: #444;
  font-family: 'Open Sans', Arial, Helvetica, sans-serif;
  font-size: 13px;
  line-height: 21px;
  margin: 0 0 40px;
  padding: 0;
}

.home__header {
  width: 95%;
  max-width: 950px;
  margin: auto;
}

header {
  background: url('../../assets/img/hero.svg') center center no-repeat;
  margin-top: 20px;
  margin-bottom: 10px;
  background-size: contain;
  @media (min-width: 600px) {
    height: 282px;
  }
}

.logo {
  float: none;
  margin: 20px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  h2 {
    padding: 0;
    margin: 15px 0;
    font-size: 24px;
    font-weight: 300;
    color: #0d3863;
    line-height: 30px;
    a {
      color: #3f7fa0;
      font-size: 20px;
      padding: 9px 0;
      font-weight: 600;
    }
    &,
    a span {
      color: #777;
      font-size: 16px;
    }
  }
  @media (min-width: 600px) {
    float: left;
    margin-right: 25px;
    margin-top: 30px;
    width: auto;
    display: block;
    h2 {
      font-size: 30px;
      line-height: 35px;
      a {
        font-size: 27px;
      }
      &,
      a span {
        font-size: 19px;
      }
    }
  }
}

.user {
  width: 100%;
  margin-top: 10px;
  float: none;
  text-align: center;
  @media (min-width: 600px) {
    width: auto;
    margin-top: 15px;
    float: right;
    text-align: right;
  }
}

nav {
  float: none;
  width: 100%;
  margin-top: 15px;
  border: 1px solid #d3d3d3;
  border-color: #ddd #d3d3d3 #c1c1c1 #d3d3d3;
  border-radius: 2px;
  background-image: linear-gradient(
    to bottom,
    #fafafa 0px,
    #efefef 70%,
    #f3f3f3 100%
  );
  box-shadow: 0px 3px 3px -1px #ccc;
  > ul {
    float: none;
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: center;
    > li {
      display: block;
      > a {
        display: block;
        color: #777;
        font-size: 15px;
        text-shadow: 1px 1px white;
        border-right: none;
        border-bottom: 1px solid #e1e1d1;
        padding: 12px 0;
        svg {
          display: inline-block;
          height: 14px;
          margin-bottom: -2px;
          width: 14px;
        }
        &:hover {
          background-image: linear-gradient(#eee, white);
          color: #257bc3;
        }
      }
      &.active a {
        text-decoration: none;
        background-color: #3c96c4;
        background-image: linear-gradient(
          to top,
          #297aa4 0px,
          #4ba1cd 100%
        ) !important;
        color: #f9f9f9;
        text-shadow: 1px 1px #0f4d6d;
        box-shadow: 0 3px 9px rgba(6, 100, 159, 0.075) inset;
      }
    }
  }
  @media (min-width: 600px) {
    float: left;
    width: 100%;
    margin-top: 0;
    > ul {
      float: left;
      text-align: left;
      > li {
        display: inline;
        > a {
          display: inline-block;
          border-right: 1px solid #e1e1d1;
          border-bottom: none;
          padding: 14px 17px;
        }
      }
    }
  }
}

// Responsive tweaks for small screens
@media (max-width: 599px) {
  .header-wrapper {
    font-size: 12px;
    margin-bottom: 20px;
  }
  .home__header {
    width: 100%;
    padding: 0 5px;
  }
  header {
    height: 120px;
    margin-top: 10px;
    margin-bottom: 5px;
  }
}
</style>